"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@owlcat/ui";

// Route-level error boundary — themed @owlcat/ui fallback with localized copy.
// Client component (Next requirement); client-side console.error is for local
// visibility only. The authoritative server-side log line is emitted by
// instrumentation.onRequestError (@owlcat/observability); the digest links the
// two. Mirrors src/portal's localized route error boundaries.
export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <div className="max-w-md text-center">
        <div className="text-5xl" aria-hidden>
          ⚠️
        </div>
        <h2 className="mt-4 mb-2 text-xl font-semibold text-foreground">
          {t("error.title")}
        </h2>
        {error?.digest && (
          <p className="text-xs text-muted-foreground">Error ID: {error.digest}</p>
        )}
        <Button type="button" variant="outline" onClick={reset} className="mt-4">
          {t("tryAgain")}
        </Button>
      </div>
    </div>
  );
}
